import React from 'react';
import PropTypes from 'prop-types';
import Router, { Link } from '../../routes';

const CustomLink = ({
  route,
  locale: newLocale,
  queryParams,
  children,
  className,
  tag,
  title,
  style,
  to,
  onClick,
  target,
  locale,
  page,
  ...props
}) => {
  const TagName = tag;

  const child = (
    <TagName
      style={style}
      title={title}
      to={to}
      onClick={onClick}
      target={target}
      className={[className, route === page ? 'active' : null].join(' ')}
    >
      {children}
    </TagName>
  );

  if (page === '_error') {
    return React.Children.map(child, element =>
      React.cloneElement(element, {
        href: `/${locale}${Router.getRoutePath(route, queryParams)}`,
      }),
    );
  }

  return (
    <Link route={route} locale={newLocale || locale} queryParams={queryParams} {...props}>
      {child}
    </Link>
  );
};

CustomLink.propTypes = {
  route: PropTypes.string.isRequired,
  locale: PropTypes.string,
  page: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  tag: PropTypes.string,
  className: PropTypes.string,
  queryParams: PropTypes.object,
  children: PropTypes.any,
  title: PropTypes.string,
  style: PropTypes.object,
  target: PropTypes.string,
};

CustomLink.defaultProps = {
  tag: 'a',
  to: '',
  page: '',
  onClick: () => {},
  locale: null,
  className: null,
  queryParams: {},
  children: null,
  title: null,
  style: {},
  target: '',
};

export default CustomLink;
